export const MIN_LATITUDE = -90
export const MAX_LATITUDE = 90

export const MIN_LONGITUDE = -180
export const MAX_LONGITUDE = 180

// 6 decimal places is ~10 cm, more than enough to place a lock
export const GEO_POINT_PRECISION = 6

// Used by the map picker when there is no point yet - center of Poland
export const DEFAULT_MAP_CENTER = { latitude: 52.0693, longitude: 19.4803 }
export const DEFAULT_MAP_ZOOM = 6
export const GEO_POINT_MAP_ZOOM = 17
